<template>
  <div class="centered-container">
    <div class="centered-content">
      <v-progress-circular
        size="100"
        indeterminate
        color="gray"
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { nonSaveCookie } from "@/store/cookie";

export default {
  async created() {
    this.code = this.$route.query.code;

    console.log(this.code);

    const res = await axios.get(
      `${process.env.VUE_APP_CONNECT}/users/auth/chathess/token/${this.code}`
    );

    console.log(res.data);

    sessionStorage.setItem("info2", res.data.data);
    sessionStorage.setItem("chathess", true);

    // nonSaveCookie("info2", res.data.data);
    // nonSaveCookie("chathess", "true");

    setTimeout(() => {
      this.$router.push({ path: "/" });
    }, 500);
  },
};
</script>

<style>
.centered-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.centered-content {
  position: relative;
}
</style>